var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfoBlack = function SvgInfoBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.168 13.888h1.648l.416-5.472.08-2.384h-2.64l.08 2.384.416 5.472ZM12 18.16c.8 0 1.408-.592 1.408-1.424S12.8 15.328 12 15.328c-.816 0-1.424.576-1.424 1.408S11.168 18.16 12 18.16Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#000"
  }))));
};
export default SvgInfoBlack;